/*
|--------------------------------------------------------------------------
| Views: Video Article
|--------------------------------------------------------------------------
*/

/**
 * Video Article
 * @namespace
 */
__gh__webApp.views.videoArticle = {

	"getSubView": function(bucket){
		var thirdPartyData 	= __gh__coreData["3rdPartyData"],
			toutID			= thirdPartyData.video.tout.id;

		bucket.toutID		= toutID;
		bucket.view.name 	= "buckets/videoArticle/default";

		return bucket;
	}
};